export default "__VITE_ASSET__DhcKjUP2__"